export interface WebPickedImageAsset {
  uri: string;
  fileName?: string;
  type?: string;
  fileSize?: number;
}

export interface WebPickImagesResult {
  assets: WebPickedImageAsset[];
}

const isBrowser = () => typeof document !== 'undefined' && typeof window !== 'undefined';

export const pickWebImages = async (options?: {
  selectionLimit?: number;
  accept?: string;
}): Promise<WebPickImagesResult | null> => {
  if (!isBrowser()) return null;

  const selectionLimit = options?.selectionLimit;
  const accept = options?.accept ?? 'image/*';

  return new Promise<WebPickImagesResult | null>((resolve) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = accept;
    input.multiple = typeof selectionLimit === 'number' ? selectionLimit !== 1 : true;

    // Some browsers require the element to be attached for `.click()` to open the picker.
    input.style.position = 'fixed';
    input.style.left = '-9999px';
    document.body.appendChild(input);

    const cleanup = () => {
      try {
        document.body.removeChild(input);
      } catch {
        // ignore
      }
    };

    input.onchange = () => {
      const files = Array.from(input.files ?? []);
      cleanup();

      if (files.length === 0) {
        resolve(null);
        return;
      }

      const limited = typeof selectionLimit === 'number' && selectionLimit > 0
        ? files.slice(0, selectionLimit)
        : files;

      const assets: WebPickedImageAsset[] = limited.map((file) => ({
        uri: URL.createObjectURL(file),
        fileName: file.name,
        type: file.type,
        fileSize: file.size,
      }));

      resolve({ assets });
    };

    input.click();
  });
};

